<template xmlns:v-clipboard="http://www.w3.org/1999/xhtml">
    <div>
      <div class="box">
        <!-- <div class="downloadBox">
          <div class="logo">
            <img :src="datas.logo" alt="">
          </div>
          <div class="text">
            <span>{{datas.web_title}}</span>
            <span>为您提供全网优惠卷</span>
          </div>
          <div class="download" @click="jumpDownload()">
            <span>立即下载</span>
          </div>
        </div> -->
        <div class="particulars">
          <div class="goods_carousel" v-if="detailObj" ref="swiper">
            <swiper :options="swiperOptionOne" ref="smallImages">
              <swiper-slide class="goods_swiper" v-for="(item, index) in detailObj.thumbs" :key="index">
                <img :src="item" :key="item">
              </swiper-slide>
            </swiper>
            <p class="goods_page_box" v-if="detailObj.thumbs && detailObj.thumbs.length"><span>{{index + 1}}</span>/{{detailObj.thumbs.length}}</p>
          </div>
          <div class="titleBox" v-if="detailObj">
            <p class="shopTitle">{{detailObj.goodsName}}</p>
            <div class="priceBox">
              <!-- <p class="newPrice">￥<span>{{detailObj.ex_price}}</span></p><del>￥{{detailObj.marketprice}}</del> -->
              <p class="newPrice">￥<span>{{detailObj.spe_price}}</span></p><del>￥{{detailObj.marketprice}}</del>
            </div>
            <div class="distributionBox" v-if="detailObj">
              <p class="distribution">配送方式:{{detailObj.freeShippingInfo}}</p>
              <p class="market">已售:{{detailObj.sales}}</p>
              <p class="distributionCity">{{detailObj.shopInfo.birth}}</p>
            </div>
          </div>
          <!-- <div class="standardBox">
            <span class="standardText"></span>
            <p class="descText"></p>
            <img class="standardIcon" src="" alt="">
          </div> -->
          <div class="merchantBox" v-if="detailObj">
            <div class="merchantTitle">
              <div class="merchantLogoBox">
                <img class="merchantLogo" :src="detailObj.shopInfo.logo" alt="">
                <p class="merchantName">{{detailObj.shopInfo.title}}</p>
              </div>
              <div class="consernsBox">
                <img class="consernsIcon" src="" alt="">
                <p class="consernsText" @click="jumpDownload()">关注</p>
              </div>
            </div>
            <div class="btnBox">
              <div class="allBtn" @click="jumpDownload()">全部宝贝</div>
              <div class="merchantBtn" @click="jumpDownload()">进店逛逛</div>
            </div>
          </div>
          <div class="shopDescTitle" v-if="detailObj">
            <div class="leftSlid"></div>
            <div class="titleImg">宝贝详情</div>
            <div class="rightSlid"></div>
          </div>
          <div class="shopDesc" v-if="detailObj" v-html="detailObj.info"></div>
        </div>
        <div class="purchase" @click="jumpDownload()">
          立即购买
        </div>
        <div class="shade" v-show="shows">
          <div class="popUp">
            <div class="word">
              淘口令购买
              <span class="mistake" @click="shut">×</span>
            </div>
            <div class="copy">
              <span>长按选择>> </span>
              <span class="copys">拷贝</span>
            </div>
            <span class="code" id="code">{{datas.code}}</span>
            <div class="duplication" id="duplication"
                 v-clipboard:copy="datas.code"
                 v-clipboard:success="onCopy"
                 v-clipboard:error="onError">复制</div>
            <span class="sm">点击复制后，请打开【手机淘宝】购买!</span>
          </div>
        </div>
      </div>
      <!--<div class="show" v-show="win">-->
        <!--复制成功-->
      <!--</div>-->
      <a href="#" class="allow" v-show="codes">无效的code</a>
    </div>
</template>

<script>
import { Toast } from 'mint-ui'
import axios from 'axios'
import qs from 'qs'
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  name: 'commodity',
  components: {
    swiper,
    swiperSlide
  },
  data () {
    return {
      codes: false,
      datas: {},
      invitation_img: [],
      shows: false,
      // messages: 'aaa',
      win: false,
      index: 0,
      isCouponPass: 1,
      up_operator: '运营商',
      type: 2,
      showDetail: true,
      other: '',
      item_id: '',
      score: '',
      rate: '',
      description: '',
      info_img: '',
      img_http: 'https://app.youquanyun.com/assets_kuaizhan/',
      // img_http: 'https://yd.yidamall.vip/assets_kuaizhan/',
      swiperOptionOne: {
        loop: true,
        on: {
          transitionEnd: () => {
            if (this.$refs.smallImages.swiper) {
              this.index = this.$refs.smallImages.swiper.realIndex
            }
          },
          sliderMove: function (event) {
            window.canRightSlipBack = false
          },
          touchEnd: function (event) {
            setTimeout(() => {
              window.canRightSlipBack = true
            }, 600)
          }
        }
      },
      detailObj: ''
    }
  },
  methods: {
    shut () {
      this.shows = false
    },
    purchase () {
      this.shows = true
    },
    onCopy (e) {
      Toast({
        message: '复制成功',
        className: 'coln'
      })
      let that = this
      this.cut = false
      this.shows = true
      // this.win = true
      window.setTimeout(refreshCount, 1000)
      function refreshCount () {
        // that.shows = false
        // that.win = false
        console.log(that.shows)
      }
    },
    onError (e) {
      console.error(e)
    },
    jumpDownload () {
      this.$router.push({
        path: '/download',
        query: {code: this.code}
      })
    },
    getDetail (code, goodsId, bizId) {
      axios.post(this.GLOBAL.apiUrl + '/api/' + bizId + '/mall/index/goods-detailkz', {goodsId: goodsId, code: code}).then((resdetail) => {
        if (resdetail.data.code === 0) {
          this.detailObj = resdetail.data.data.detail
          console.log(this.detailObj)
        }
      })
    }
  },
  mounted () {
    let code = this.GLOBAL.getQueryString('code')
    let goodsId = this.GLOBAL.getQueryString('goodsid')
    let bizId = this.GLOBAL.getQueryString('biz_id')
    // let code = 'MV84NDA5XzU4OTI0Mjk3NjA2Ng=='
    if (!code) {
      this.codes = true
    }
    if (!bizId) {
      bizId = this.GLOBAL.bizId
    }
    axios.defaults.headers = {
      'Content-type': 'application/x-www-form-urlencoded'
    }
    axios.defaults.transformRequest = (data) => {
      data = qs.stringify(data)
      return data
    }
    this.getDetail(code, goodsId, bizId)
    // axios.get(this.GLOBAL.apiUrl + '/api/w1/share/download/?code=' + code).then((res) => {
    //   if (res.data.code === 0) {
    //     this.datas = res.data.data
    //     this.invitation_img = res.data.data.img
    //     document.title = res.data.data.title
    //     axios.defaults.headers = {
    //       'Content-type': 'application/x-www-form-urlencoded'
    //     }
    //     axios.defaults.transformRequest = (data) => {
    //       data = qs.stringify(data)
    //       return data
    //     }
    //     this.getDetail(code)
    //   }
    // })
    /* axios(
    {
      method: 'post',
      url: 'http://app.youquanyun.com/api/1/amoy/taobao/goods-detail',
      data: {
        'item_id': '589242976066'
      }
    }
    ) */
  }
}
</script>
<style lang="less">
  .swiper-pagination-clickable .swiper-pagination-bullet{
    transform: scale(1);
  }
  .swiper-pagination{
    bottom: 0.2rem;
  }
  .swiper-pagination{
    left: 50%;
    transform: translateX(-50%);
    width: 200px
  }
  .swiper-pagination li{
    margin: 0 5px;
  }
  .swiper-pagination-bullet{
    opacity: 1;
    background-color: rgba(0,0,0,0.4);
  }
  .swiper-pagination-bullet-active{
    background-color: #007aff;
  }
  .swiper-pagination{
    width: 200px;
  }
  .mint-toast is-placemiddle{
    width: 4rem;
  }
  .coln{
    width: 2.8rem;
    height: 1.1rem;
    line-height: 1.1rem;
    /*padding: 0.3rem 0!important;*/
    margin-top: -0.2rem;
    background-color: rgba(0,0,0,0.6);
    color: #fff;
    /*background-color: #000;*/
    font-size: 0.32rem;
    border-radius: 5px;
    box-sizing: border-box;
    padding: 0!important;
  }
</style>

<style lang="less" scoped>
  .show{
    color: #fff;
    position: fixed;
    top: 273px;
    width: 120px;
    height: 40px;
    font-size: 13px;
    text-align: center;
    line-height: 40px;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 10px;
    background-color: black;
    opacity: 0.7;
    /*display: none;*/
    z-index: 999;
  }
  .swiperBox {
    /*width: 100%;*/
    position: relative;
    height: 7.2rem;
    overflow: hidden;
  }
  .swiperBox .swiper {
    /*margin-top: 0.5rem;*/
  }
  .swiperBox .bgc {
    width: 100%;
    height: 2rem;
    position: absolute;
    top: -0.5rem;
    left: 0;
  }
  .swiperBox .bgc img {
    width: 100%;
    height: 100%;
  }
  .swiperBox .items {
    position: absolute;
    width: 0.80rem;
    height: 1.7rem;
    top: 1.14rem;
    right: 0.16rem;
  }
  .swiperBox .items .piece {
    width: 0.8rem;
    height: 0.8rem;
    color: red;
    font-size: 0.26rem;
    text-align: center;
    background-color: #fff;
    opacity: 0.7;
    border-radius: 4px;
  }
  .swiperBox .items .piece span {
    display: block;
  }
  .swiperBox .items .img {
    width: 0.8rem;
    height: 0.8rem;
    top: 0.1rem;
    position: relative;
  }
  .swiperBox .items .img img {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
  }
  .banner {
    height: 7.2rem;
    width: 100%;
    background-color: #f7f7f7;
  }
  .banner img {
    width: 100%;
    /*height: 100%;*/
  }
  body,div,dl,dt,dd,ul,ol,li,h1,h2,h3,h4,h5,h6,pre,code,form,fieldset,legend,input,textarea,p,blockquote,th,td,hr,button,article,aside,details,figcaption,figure,footer,header,hgroup,menu,nav,section {
    margin:0;
    padding:0
  }
  .box{
    position: relative;
    // padding-bottom: 1.1rem;
    background: #F7F7F7;
  }
  .downloadBox{
    width: 100%;
    padding: 0.1rem 0.15rem;
    background-color: #4c4c4c;
    height: 1.0rem;
    box-sizing: border-box;
    overflow: hidden;
  }
  .logo{
    float: left;
    width: 0.80rem;
    height: 0.80rem;
    position: relative;
  }
  .logo img{
    position: absolute;
    width: 100%;
    height: 100%;
  }
  .text{
    float: left;
    margin-left: 0.3rem;
    color: #fff;
  }
  .text span{
    display: block;
  }
  .text span:nth-child(1){
    font-size: 0.3rem;
    line-height: 0.5rem;
  }
  .text span:nth-child(2){
    font-size: 0.22rem;
    line-height: 0.3rem;
  }
  .download{
    float: right;
    padding: 0.1rem 0;
  }
  .download span{
    display: block;
    width: 1.80rem;
    height: 0.6rem;
    line-height: 0.6rem;
    border-radius: 0.1rem;
    text-align: center;
    font-size: 0.3rem;
    color: #fff;
    background: linear-gradient(270deg,rgba(255,142,118,1),rgba(255,88,71,1));
  }

  .explain .texts{
    display: block;
    padding: 0 0.3rem;
    padding-top: 0.28rem;
    font-size: 0.3rem;
    color: black;
    overflow : hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .message{
    overflow: hidden;
    margin-top: 0.3rem;
    padding: 0 0.2rem;
  }
  .message div{
    float: left;
  }
  .message div:nth-child(1){
    font-size: 0.3rem;
    color: #fc3357;
    font-weight: 800;
  }
  .pan1{
    font-size: 0.28rem;
    font-weight: bold;
  }
  .jiage{
    font-size: 0.45rem;
  }
  .quan{
    margin-left: 0.4rem;
    height: 0.4rem;
    border: 1px solid #fc3357;
    margin-top: 0.1rem;
  }
  .quan span:nth-child(1){
    font-size: 0.3rem;
    float: left;
    border-right: 1px solid #fc3357;
    padding: 0 0.04rem;
    color: #fff;
    background: linear-gradient(to right, #ff485f , #ffa880)
  }
  .quan span:nth-child(2){
    float: right;
    font-size: 0.24rem;
    padding: 0rem 0.16rem;
    line-height: 0.4rem;
    color: #fc3357;
  }
  .message .sell{
    line-height: 0.6rem;
    float: right;
    font-size: 0.22rem;
    color: #c2c2c2;
  }
  .purchase{
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    line-height: 1.0rem;
    display: block;
    font-size: 0.3rem;
    color: #fff;
    text-align: center;
    text-decoration:none;
    background: linear-gradient(270deg,rgba(255,142,118,1),rgba(255,88,71,1));
  }
  .popUp{
    border-radius: 9px;
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    top: 3.74rem;
    width: 6rem;
    height: 5.88rem;
  }
  .shade{
    /* width: 100%;
    height: 100%; */
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0,0,0,0.8);
    position: absolute;
    top: 0;
    left: 0;
    z-index: 999;
  }
  .popUp{
    background-color: #fff;
  }
  .word{
    border-top-left-radius:8px;
    border-top-right-radius:8px;
    height: 1rem;
    width: 100%;
    font-size: 0.3rem;
    text-align: center;
    line-height: 1rem;
    background: linear-gradient(270deg,rgba(255,142,118,1),rgba(255,88,71,1));;
    color: #fff;
  }
  .mistake{
    position: absolute;
    top: -2.2px;
    right: 0px;
    font-size: 0.6rem;
    width: 46px;
    /*height: 12px;*/
  }
  .copy{
    position: absolute;
    font-size: 0.22rem;
    color: #666;
    width: 3.30rem;
    height: 0.5rem;
    background-color: #ffe8e6;
    border-radius: 4px;
    margin: 0.4rem  auto;
    text-align: center;
    line-height: 0.5rem;
    left: 50%;
    transform: translateX(-50%);
    z-index: 999;
    top: 0.8rem;
  }
  .copy span:nth-child(2){
    color: rgba(255,88,71,1);
  }
  .code{
    position: relative;
    margin: 0.4rem;
    height: 1.2rem;
    line-height: 1.5rem;
    border: 1px dashed #fc3357;
    text-align: center;
    font-size: 0.32rem;
    color: black;
    font-weight: 800;
    display: block;
    margin-top: 0.4rem;
  }
  .duplication{
    height: 0.76rem;
    width: 3rem;
    margin: 0.5rem auto;
    font-size: 0.32rem;
    color: #fff;
    background: linear-gradient(270deg,rgba(255,142,118,1),rgba(255,88,71,1));;
    border-radius: 21px;
    text-align: center;
    line-height: 0.76rem;
  }
  .sm{
    font-size: 0.22rem;
    color: #7d5a5a;
    display: block;
    margin: 0 0.8rem;
    text-align: center;
  }
  .show{
    color: #fff;
    position: fixed;
    top: 273px;
    width: 120px;
    height: 40px;
    font-size: 13px;
    text-align: center;
    line-height: 40px;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 10px;
    background-color: black;
    opacity: 0.7;
    /*display: none;*/
    z-index: 999;
  }
  .swiper-container {
    /*height: 420px;*/
  }
  .swiper-slide img{
    width: 100%;
    height: 100%;
  }
  a{
    text-decoration:none;
    color: #fff;
  }
  .particulars{
    position: relative;
    .goods_carousel{
      position: relative;
      font-size: 0;
    }
    .goods_carousel .goods_page_box{
      z-index: 3;
      padding: 0 .2rem;
      color: #fff;
      border-radius: .2rem;
      justify-content: center;
      letter-spacing: 3px;
      display: flex;
      align-items: center;
      position: absolute;
      right: .30rem;
      bottom: .5rem;
      height: .4rem;
      font-size: .2rem;
      background: rgba(0,0,0,0.4);
    }
    .titleBox{
      position: relative;
      width: 7.5rem;
      box-sizing: border-box;
      padding: 0.3rem 0.3rem;
      background: #fff;
      p.shopTitle{
        color: #333333;
        font-size: 0.3rem;
        line-height: 0.36rem;
      }
      .priceBox{
        width: 6.9rem;
        display: flex;
        justify-content: flex-start;
        align-items: flex-end;
        color: #fc3357;
        margin-top: 0.48rem;
        font-weight: 600;
        p.newPrice{
          font-size: 0.26rem;
          span {
            font-size: 0.38rem;
          }
        }
        del {
          font-size: 0.25rem;
          font-weight: normal;
          color: rgb(204, 204, 204);
          margin-left: 0.2rem;
        }
      }
      .distributionBox{
        width: 6.9rem;
        margin-top: 0.48rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 0.26rem;
        color: #a1a1a1;
        .distribution{
        }
        .market{
        }
        .distributionCity{
        }
      }
    }
    .merchantBox{
      position: relative;
      width: 7.5rem;
      margin-top: 0.2rem;
      margin-bottom: 0.2rem;
      background: #fff;
      box-sizing: border-box;
      padding: 0.3rem 0.3rem 0.45rem 0.3rem;
      .merchantTitle{
        width: 6.9rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .merchantLogoBox{
          display: flex;
          justify-content: center;
          align-items: center;
          .merchantLogo{
            width: 0.75rem;
          }
          .merchantName{
            font-size: 0.3rem;
            font-weight: 500;
            line-height: 0.32rem;
            margin-left: 0.2rem;
            color: #333333;
          }
        }
        .consernsBox{
          display: flex;
          justify-content: center;
          align-items: center;
          .consernsIcon{
            width: 0.3rem;
            margin-right: 0.1rem;
          }
          .consernsText{
            height: 0.5rem;
            margin-right: 0.05rem;
            padding-left: 0.2rem;
            padding-right: 0.2rem;
            font-size: 0.26rem;
            font-weight: 500;
            color: #fff;
            line-height: 0.5rem;
            background: linear-gradient(270deg,rgba(255,142,118,1),rgba(255,88,71,1));
            border-radius: 0.25rem;
          }
        }
      }
      .btnBox{
        width: 6.9rem;
        margin-top: 0.3rem;
        display: flex;
        justify-content: space-around;
        align-items: center;
        .allBtn{
          width: 1.83rem;
          height: 0.6rem;
          box-sizing: border-box;
          border: 0.01rem solid #fc3357;
          text-align: center;
          font-size: 0.28rem;
          line-height: 0.6rem;
          color: #fc3357;
          border-radius: 0.3rem;
        }
        .merchantBtn{
          width: 1.83rem;
          height: 0.6rem;
          background: #fc3357;
          border-radius: 0.3rem;
          font-size: 0.28rem;
          line-height: 0.6rem;
          color: #fff;
          text-align: center;
        }
      }
    }
    .shopDescTitle{
      position: relative;
      overflow: hidden;
      width: 7.5rem;
      height: 1rem;
      margin-bottom: 0.2rem;
      background: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      .leftSlid{
        width: 1.7rem;
        height: 0.01rem;
        background: rgba(173,172,171,0.4);
      }
      .titleImg{
        margin-left: 0.2rem;
        margin-right: 0.2rem;
        font-size: 0.3rem;
        font-weight: 500;
        color: #333;
      }
      .rightSlid{
        width: 1.7rem;
        height: 0.01rem;
        background: rgba(173,172,171,0.4);
      }
    }
    /deep/.shopDesc{
      position: relative;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 7.5rem;
      box-sizing: border-box;
      background: #fff;
      padding: 0 0.17rem;
      min-height: 500px;
      word-wrap: break-word;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      font-size: 0;
      padding-bottom: 1rem;
      img {
        max-width: 100% !important;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/shopInfo.vue